import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["options"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { EMPTY_ARRAY, EMPTY_STRING } from '@tekion/tekion-base/app.constants';
import { getGroupedOptions } from '../helpers/advancedSelect.general';
export default function withGroupedDynamicAsyncSelect(SelectComponent) {
  var WithGroupedDynamicAsyncSelect = /*#__PURE__*/function (_PureComponent) {
    _inherits(WithGroupedDynamicAsyncSelect, _PureComponent);
    var _super = _createSuper(WithGroupedDynamicAsyncSelect);
    function WithGroupedDynamicAsyncSelect() {
      _classCallCheck(this, WithGroupedDynamicAsyncSelect);
      return _super.apply(this, arguments);
    }
    _createClass(WithGroupedDynamicAsyncSelect, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
          options = _this$props.options,
          props = _objectWithoutProperties(_this$props, _excluded);
        return /*#__PURE__*/React.createElement(SelectComponent, _extends({}, props, {
          options: getGroupedOptions(options)
        }));
      }
    }]);
    return WithGroupedDynamicAsyncSelect;
  }(PureComponent);
  WithGroupedDynamicAsyncSelect.propTypes = {
    groupedStaticOptions: PropTypes.array,
    options: PropTypes.array,
    asyncGroupLabel: PropTypes.string
  };
  WithGroupedDynamicAsyncSelect.defaultProps = {
    groupedStaticOptions: EMPTY_ARRAY,
    options: EMPTY_ARRAY,
    asyncGroupLabel: EMPTY_STRING
  };
  return WithGroupedDynamicAsyncSelect;
}